import { fetch } from 'http-common';

type UpdateOrderData = {
  id: string;
  newIndex: number;
};

class SelectionDataService {
  private http = fetch();

  private ep = '/v1/selection';

  public async getAll(season: string, warehouse: string) {
    return this.http.get(`${this.ep}/${season}/all?warehouse=${warehouse}`);
  }

  public async post(season: string, name: string, warehouse: string) {
    return this.http.post(`${this.ep}?season=${season}&name=${name}&warehouse=${warehouse}`);
  }

  public async postProduct(id: string, productId: string) {
    return this.http.post(`${this.ep}/product/${id}/${productId}`);
  }

  public async get(id: string, lang: string) {
    return this.http.get(`${this.ep}/selectionProducts/${id}?lang=${lang}`);
  }

  public async deleteList(id: number) {
    return this.http.delete(`${this.ep}/${id}`);
  }

  public async deleteProduct(id: string) {
    return this.http.delete(`${this.ep}/product/${id}`);
  }

  public async updateOrder(id: string, lang: string, data: UpdateOrderData[]) {
    return this.http.put(`${this.ep}/updateSorting/${id}`, data, {
      params: {
        lang,
      },
    });
  }
}

const selectionDataService = new SelectionDataService();

export { selectionDataService };
